var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":`${_vm.docsUrl}/${_vm.endpoint}`,"target":"_blank"}},[_vm._v("How it works?")])
}
var staticRenderFns = []

export { render, staticRenderFns }